// removed by extract-text-webpack-plugin
module.exports = {"primary_main":"#ffca28","primary_dark":"#c79a00","contrast_text_black":"#000","secondary_main":"#999a9a","secondary_dark":"#37474f","contrast_text_white":"#fff"};